const REVOKE_AFTER_MS = 60_000;

/** Opens a PDF the app fetches with its bearer token. The browser cannot
    attach that header to a plain link, so the bytes arrive as a Blob and are
    shown through an object URL.

    The tab is opened before the fetch, while the tap still counts as a user
    gesture: Safari blocks a window.open that follows an await. `noopener`
    can't be passed here because it makes window.open return null, which is
    what used to send the app itself to the PDF. If the tab is blocked anyway,
    the file downloads instead, and the app stays where it is. */
export async function openPdf(load: () => Promise<Blob>, filename = "report.pdf"): Promise<void> {
  const tab = window.open("", "_blank");
  let blob: Blob;
  try {
    blob = await load();
  } catch (error) {
    tab?.close();
    throw error;
  }
  const url = URL.createObjectURL(new Blob([blob], { type: "application/pdf" }));
  if (tab) {
    tab.opener = null;
    tab.location.href = url;
  } else {
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    link.click();
  }
  window.setTimeout(() => URL.revokeObjectURL(url), REVOKE_AFTER_MS);
}
